import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/design-tokens.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./components/Auth/AuthProvider";
import {BrowserRouter} from 'react-router-dom';
import {ConfigProvider} from 'antd';
import {Provider} from "react-redux";
import store from "./components/util/redux";
import {SCRoutes as Routes} from './routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Provider store={store}>
      <ConfigProvider theme={{token: {colorPrimary: '#ef7721'}}}>
      <AuthProvider>
          <BrowserRouter>
                <Routes />
          </BrowserRouter>
      </AuthProvider>
      </ConfigProvider>
      </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
